import React, { useEffect } from 'react';
import { useSubdomain } from '../contexts/SubdomainContext';
import { useMobileLayout } from '../hooks/useMobileLayout';
import { appNavigate } from '../utils/appNavigate';
import { labelLinkHubPath, labelLinkPickPath } from '../utils/labelLinkPaths';

/** Redirects legacy /labels/associate?barcode= to the appropriate flow. */
export const InventoryLabelAssociateRoute: React.FC = () => {
  const { subdomain } = useSubdomain();
  const isMobile = useMobileLayout();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const barcode = params.get('barcode')?.trim();
    const prefix = subdomain ? `/${subdomain}` : '';
    if (barcode) {
      if (isMobile) {
        appNavigate(labelLinkPickPath(subdomain, barcode));
      } else {
        appNavigate(`${prefix}/containers?assignLabel=${encodeURIComponent(barcode)}`);
      }
    } else if (isMobile) {
      appNavigate(labelLinkHubPath(subdomain));
    } else {
      appNavigate(`${prefix}/`);
    }
  }, [subdomain, isMobile]);

  return null;
};

export default InventoryLabelAssociateRoute;
